import { PressPageContent } from '../../components/pages/press';
import Layout from '../../components/shared/Layout';
import { usePageVistTracker } from '../../hooks/usePageVistTracker';

const Press: React.FC = () => {
  usePageVistTracker();

  return (
    <Layout
      description="Press support is invaluable to us. Every story helps advance public education on the science of sound as medicine."
      pageTitle="Press & Media"
    >
      <PressPageContent />
    </Layout>
  );
};

export default Press;
